exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".theme-default .cv-event{border-radius:.25rem}.theme-default .cv-event.continued:before,.theme-default .cv-event.toBeContinued:after{color:#fff!important}", ""]);

